export const soundLibrary = [
  {
    id: "ambience",
    name: "Ambience",
    defaultFreqBands: ["low-mid", "mid"],
    defaultStereoPresence: ["medium", "wide"],
    defaultDepth: ["back"],
    defaultShape: ["transient", "sustained"],
  },
  {
    id: "arp",
    name: "Arpeggiator",
    defaultFreqBands: ["low-mid", "mid", "high"],
    defaultStereoPresence: ["narrow", "medium"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["transient"],
  },
  {
    id: "bass",
    name: "Bass",
    defaultFreqBands: ["low", "low-mid"],
    defaultStereoPresence: ["narrow", "wide"],
    defaultDepth: ["front"],
    defaultShape: ["transient", "sustained"],
  },
  {
    id: "bell",
    name: "Bell",
    defaultFreqBands: ["mid", "high"],
    defaultStereoPresence: ["narrow", "medium"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["transient"],
  },
  {
    id: "brass",
    name: "Brass",
    defaultFreqBands: ["low-mid", "mid", "high"],
    defaultStereoPresence: ["narrow", "medium"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["transient", "sustained"],
  },
  {
    id: "flute",
    name: "Flute",
    defaultFreqBands: ["mid", "high"],
    defaultStereoPresence: ["narrow", "medium"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["transient", "sustained"],
  },
  {
    id: "guitar",
    name: "Guitar",
    defaultFreqBands: ["low-mid", "mid", "high"],
    defaultStereoPresence: ["narrow", "medium"],
    defaultDepth: ["middle", "back"],
    defaultShape: ["transient"],
  },
  {
    id: "keys",
    name: "Keys",
    defaultFreqBands: ["low-mid", "mid", "high"],
    defaultStereoPresence: ["narrow", "medium"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["transient"],
  },
  {
    id: "lead",
    name: "Lead",
    defaultFreqBands: ["mid", "high"],
    defaultStereoPresence: ["narrow", "medium"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["sustained"],
  },
  {
    id: "organ",
    name: "Organ",
    defaultFreqBands: ["low-mid", "mid"],
    defaultStereoPresence: ["narrow", "medium"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["sustained"],
  },
  {
    id: "pad",
    name: "Pad",
    defaultFreqBands: ["low-mid", "mid"],
    defaultStereoPresence: ["medium", "wide"],
    defaultDepth: ["middle", "back"],
    defaultShape: ["sustained"],
  },
  {
    id: "percussion",
    name: "Percussion",
    defaultFreqBands: ["mid", "high"],
    defaultStereoPresence: ["narrow", "medium", "wide"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["transient"],
  },
  {
    id: "pluck",
    name: "Pluck",
    defaultFreqBands: ["mid", "high"],
    defaultStereoPresence: ["narrow", "medium"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["transient"],
  },
  {
    id: "strings",
    name: "Strings",
    defaultFreqBands: ["mid", "high"],
    defaultStereoPresence: ["medium", "wide"],
    defaultDepth: ["middle", "back"],
    defaultShape: ["sustained"],
  },
  {
    id: "synth",
    name: "Synthesizer",
    defaultFreqBands: ["low-mid", "mid", "high"],
    defaultStereoPresence: ["narrow", "medium", "wide"],
    defaultDepth: ["front", "middle"],
    defaultShape: ["transient", "sustained"],
  },
];
